const en: Record<string, string> = {
  'golf.common.active': 'Active',
  'golf.common.admin': 'Admin',
  'golf.common.age': 'Age',
  'golf.common.alert': 'Alert',
  'golf.common.amount': 'Amount',
  'golf.common.cancel': 'Cancel',
  'golf.common.close': 'Close',
  'golf.common.create': 'Create',
  'golf.common.created': 'Created',
  'golf.common.days_fri': 'Fri',
  'golf.common.days_mon': 'Mon',
  'golf.common.days_sat': 'Sat',
  'golf.common.days_sun': 'Sun',
  'golf.common.days_thu': 'Thu',
  'golf.common.days_tue': 'Tue',
  'golf.common.days_wed': 'Wed',
  'golf.common.delete': 'Delete',
  'golf.common.delete_confirm':
    'Are you sure you want to delete area "{name}"?',
  'golf.common.details': 'Details',
  'golf.common.discard_changes': 'Discard Changes',
  'golf.common.draft': 'Draft',
  'golf.common.driving_experience': 'Driving Experience',
  'golf.common.edit': 'Edit',
  'golf.common.email': 'Email',
  'golf.common.grant': 'Grant',
  'golf.common.hourly': 'HOURLY',
  'golf.common.image_not_available': 'Image not available',
  'golf.common.name': 'Name',
  'golf.common.no': 'No',
  'golf.common.not_configured': 'Not configured',
  'golf.common.not_uploaded': 'Not uploaded',
  'golf.common.parking': 'Parking',
  'golf.common.payment_card': 'CARD',
  'golf.common.phone': 'Phone',
  'golf.common.points': 'Points',
  'golf.common.points_count': '{count} points',
  'golf.common.points_json': 'Points (JSON)',
  'golf.common.points_json_hint':
    'Array of {lat, lng} objects for polygon vertices',
  'golf.common.protocol_4point': '4-POINT PROTOCOL',
  'golf.common.quantity': 'Quantity',
  'golf.common.reason': 'Reason',
  'golf.common.revoke': 'Revoke',
  'golf.common.save': 'Save',
  'golf.common.save_changes': 'Save Changes',
  'golf.common.select': 'Select',
  'golf.common.select_type': 'Select type',
  'golf.common.status': 'Status',
  'golf.common.status_update_failed': 'Failed to update status',
  'golf.common.status_updated': 'Status updated',
  'golf.common.summary': 'Summary',
  'golf.common.system': 'System',
  'golf.common.today': 'Today',
  'golf.common.type': 'Type',
  'golf.common.units': 'Units',
  'golf.common.update': 'Update',
  'golf.common.updated': 'Updated',
  'golf.common.user': 'User',
  'golf.common.yes': 'Yes',
  'golf.dashboard.active_trips': 'ACTIVE TRIPS',
  'golf.dashboard.approved_trips': 'APPROVED TRIPS',
  'golf.dashboard.ready_to_start': 'Ready to start',
  'golf.dashboard.daily': 'Daily',
  'golf.dashboard.dispatch_service': 'Dispatch Service',
  'golf.dashboard.end_date': 'End date',
  'golf.dashboard.filtered_range': 'Filtered Range',
  'golf.dashboard.fleet_status': 'FLEET STATUS',
  'golf.dashboard.live_on_course': 'Live on course',
  'golf.dashboard.log_archive_future':
    'Log Archive will be available in future updates',
  'golf.dashboard.low_battery_alerts': 'low battery alerts',
  'golf.dashboard.notifications': 'Notifications',
  'golf.dashboard.pending_trips': 'PENDING TRIPS',
  'golf.dashboard.period_revenue': 'PERIOD REVENUE',
  'golf.dashboard.prev_week_growth': '+5.2% from prev. week',
  'golf.dashboard.requires_verification': 'Requires verification',
  'golf.dashboard.service_request': 'Service Request #12',
  'golf.dashboard.start_date': 'Start date',
  'golf.dashboard.tire_pressure_warning':
    'Tire pressure warning on VIP asset GC-002.',
  'golf.dashboard.title': 'Dashboard',
  'golf.dashboard.traffic_analytics': 'Rental Traffic Analytics',
  'golf.dashboard.view_log_archive': 'View Log Archive →',
  'golf.financial.action_charge': 'Charge',
  'golf.financial.action_freeze': 'Freeze',
  'golf.financial.action_refund': 'Refund',
  'golf.financial.action_unfreeze': 'Unfreeze',
  'golf.financial.badge_held': '[HELD]',
  'golf.financial.badge_released': '[RELEASED]',
  'golf.financial.charged': 'CHARGED',
  'golf.financial.col_deposit_status': 'DEPOSIT STATUS',
  'golf.financial.col_outstanding': 'OUTSTANDING',
  'golf.financial.col_rental_fee': 'RENTAL FEE',
  'golf.financial.col_renter': 'RENTER',
  'golf.financial.col_timestamp': 'TIME STAMP',
  'golf.financial.export_financial_report': 'Export Financial Report',
  'golf.financial.exporting_report': 'Exporting Financial Report...',
  'golf.financial.frozen': 'FROZEN',
  'golf.financial.growth': 'GROWTH +4%',
  'golf.financial.last_month': 'Last Month',
  'golf.financial.manual_amount': 'MANUAL AMOUNT (₼)',
  'golf.financial.operation_type': 'OPERATION TYPE',
  'golf.financial.payment_activity': 'Payment Activity',
  'golf.financial.please_enter_amount': 'Please enter an amount',
  'golf.financial.recent_deposit_service_desc':
    'Recent deposit/service operations related to this renter.',
  'golf.financial.recent_transactions': 'Recent Transactions',
  'golf.financial.refunded': 'REFUNDED',
  'golf.financial.renter': 'RENTER',
  'golf.financial.select_range': 'Select Range',
  'golf.financial.service_fee': 'Service Fee',
  'golf.financial.settlement': 'Settlement',
  'golf.financial.target_account': 'TARGET ACCOUNT',
  'golf.financial.this_month': 'This Month',
  'golf.financial.this_year': 'This Year',
  'golf.financial.all_time': 'All Time',
  'golf.financial.title': 'Financial Reports & Billing',
  'golf.financial.total_revenue': 'TOTAL REVENUE',
  'golf.financial.transactions_title': 'TRANSACTIONS',
  'golf.financial.valid_amount': 'Please enter a valid amount',
  'golf.fleet.actions': 'ACTION',
  'golf.fleet.active_in_resort': 'Active in Resort',
  'golf.fleet.add_make': 'Add Make',
  'golf.fleet.add_model': 'Add Model',
  'golf.fleet.all': 'All',
  'golf.fleet.asset_dialog_title': 'Asset: {id}',
  'golf.fleet.asset_info': 'Asset Information',
  'golf.fleet.assigned_make': 'ASSIGNED MAKE',
  'golf.fleet.basic_info': 'Basic Information',
  'golf.fleet.battery': 'Battery:',
  'golf.fleet.battery_label': '(BATTERY)',
  'golf.fleet.browse': 'browse',
  'golf.fleet.capacity': 'CAPACITY',
  'golf.fleet.car_details': 'Car Details',
  'golf.fleet.change_deployment_zone': 'Click to change deployment zone',
  'golf.fleet.clear_zone_assignment': 'Clear zone assignment',
  'golf.fleet.click_select_zone': 'Click to select from admin-defined zones',
  'golf.fleet.click_to_connect': 'Click to Connect',
  'golf.fleet.connect_wialon_dialog': 'Connect Wialon GPS Unit',
  'golf.fleet.connected_status': 'Connected:',
  'golf.fleet.count_models': '{count} Models',
  'golf.fleet.create_profile_subtitle':
    'Add a new golf car model to your fleet',
  'golf.fleet.create_profile_title': 'Create Golf Car Profile',
  'golf.fleet.deployment_logs_hint':
    'Deployment logs will be generated upon save.',
  'golf.fleet.detailed_description_placeholder':
    'Enter a detailed description of this golf car model...',
  'golf.fleet.disconnect': 'Disconnect',
  'golf.fleet.draft': 'Draft',
  'golf.fleet.drop_image': 'Drop image or',
  'golf.fleet.eg_gc001': 'e.g., GC-001',
  'golf.fleet.eg_make_name': 'e.g., Denago XL or Club Car Tempo',
  'golf.fleet.eg_model_seats': 'e.g., RXV 4-seat',
  'golf.fleet.eg_seats_count': 'e.g., 4 or 2',
  'golf.fleet.eg_stall_number': 'e.g., A-12',
  'golf.fleet.eg_unit_id': 'e.g., 123456',
  'golf.fleet.eg_unit_name': 'e.g., Golf Car 1',
  'golf.fleet.filter_by_asset_status': 'Filter by Asset Status:',
  'golf.fleet.filter_by_status': 'Filter by Status:',
  'golf.fleet.fleet_status_logs': 'Fleet Status Logs',
  'golf.fleet.growth_plus4': 'GROWTH +4%',
  'golf.fleet.initial_asset': 'Initial Asset',
  'golf.fleet.iot_telemetry': 'IOT TELEMETRY',
  'golf.fleet.last_telemetry': 'Last Telemetry:',
  'golf.fleet.last_update': 'Last Update:',
  'golf.fleet.location': 'Location:',
  'golf.fleet.low_battery_alerts': 'Low Battery / Service Alerts',
  'golf.fleet.make_created_success': 'Golf make created successfully!',
  'golf.fleet.make_name': 'Make Name',
  'golf.fleet.make_updated_success': 'Golf make updated successfully!',
  'golf.fleet.model_created_success': 'Model created successfully!',
  'golf.fleet.model_id': 'MODEL ID',
  'golf.fleet.model_name': 'Model',
  'golf.fleet.model_updated_success': 'Model updated successfully!',
  'golf.fleet.no_zone_assigned': 'No zone assigned',
  'golf.fleet.physical_assets': 'PHYSICAL ASSETS',
  'golf.fleet.profile_created_success':
    'Golf car profile created successfully!',
  'golf.fleet.profile_photo': 'Profile Photo',
  'golf.fleet.range': 'Range',
  'golf.fleet.range_km': 'Range (km)',
  'golf.fleet.ready': 'READY',
  'golf.fleet.resort_deployment_zone': 'Resort Deployment Zone',
  'golf.fleet.search_wialon_placeholder': 'Search by ID or Name...',
  'golf.fleet.select_from_catalog': 'Select from catalog...',
  'golf.fleet.showing_active_assets':
    'Showing {start} to {end} of {total} active assets',
  'golf.fleet.showing_active_profiles':
    'Showing {start} to {end} of {total} active profiles',
  'golf.fleet.status': 'STATUS',
  'golf.fleet.status_active': 'Active',
  'golf.fleet.status_in_use': 'In Use',
  'golf.fleet.status_inactive': 'Inactive',
  'golf.fleet.status_maintenance': 'Maintenance',
  'golf.fleet.tab_makes': 'Golf Makes',
  'golf.fleet.tab_models': 'Golf Models',
  'golf.fleet.tariff_dialog_title': 'Tariff: {name}',
  'golf.fleet.tariffs': 'TARIFFS',
  'golf.fleet.telemetry_data': 'Telemetry Data',
  'golf.fleet.title': 'Fleet Management',
  'golf.fleet.total_fleet_models': 'Total Fleet Models',
  'golf.fleet.total_inventory': 'TOTAL INVENTORY',
  'golf.fleet.total_models': 'Total Fleet Models',
  'golf.fleet.unique_chassis_hint':
    'Reference unique chassis or resort-specific numbering.',
  'golf.fleet.unit_id': 'Unit ID',
  'golf.fleet.upload_images_hint':
    'Upload 4 images of the golf car (Front, Back, Left, Right). 10MB max each.',
  'golf.fleet.view': 'View',
  'golf.fleet.wialon_unit_id': 'Wialon Unit ID:',
  'golf.fleet.wialon_unit_name': 'WIALON UNIT NAME',
  'golf.header.language_az': 'Azərbaycan',
  'golf.header.language_en': 'English',
  'golf.header.language_ru': 'Русский',
  'golf.header.pending_trips_title': 'Pending trip requests',
  'golf.header.search_placeholder': 'Search by car, user, trip...',
  'golf.header.select_language': 'Select Language',
  'golf.header.sign_out': 'Sign Out',
  'golf.map.add_area': 'Add Area',
  'golf.map.alert_area_created_success': 'Alert area created successfully',
  'golf.map.alert_area_deleted_success': 'Alert area deleted successfully',
  'golf.map.alert_area_name_placeholder': 'Alert Area Name',
  'golf.map.alert_area_updated_success': 'Alert area updated successfully',
  'golf.map.alert_areas_title': 'Alert Areas',
  'golf.map.area_created_success': 'Area created successfully',
  'golf.map.area_deleted_success': 'Area deleted successfully',
  'golf.map.area_instructions':
    'Drag markers to adjust area. Right-click point to delete.',
  'golf.map.area_must_have_3_points': 'Area must have at least 3 points',
  'golf.map.area_name_placeholder': 'Area Name',
  'golf.map.area_updated_success': 'Area updated successfully',
  'golf.map.available': 'Available:',
  'golf.map.available_assets': 'Available Assets:',
  'golf.map.create_new_alert_area': 'Create New Alert Area',
  'golf.map.create_new_area': 'Create New Area',
  'golf.map.drawing_instructions_create':
    "Click on map to add points. Click first point or 'Finish' to close. Right-click point to delete.",
  'golf.map.edit_alert_area_details': 'Edit Alert Area Details',
  'golf.map.edit_area_details': 'Edit Area Details',
  'golf.map.failed_delete_alert_area': 'Failed to delete alert area',
  'golf.map.failed_delete_area': 'Failed to delete area',
  'golf.map.failed_load_alert_areas': 'Failed to load alert areas',
  'golf.map.failed_load_areas': 'Failed to load areas',
  'golf.map.failed_save_alert_area': 'Failed to save alert area',
  'golf.map.failed_save_area': 'Failed to save area',
  'golf.map.finish_drawing': 'Finish Drawing',
  'golf.map.finish_editing_first': 'Please finish editing current area first',
  'golf.map.geographic_areas': 'Geographic Areas',
  'golf.map.golf_car_title': 'Golf Car - {name}',
  'golf.map.initializing_map': 'Initializing map...',
  'golf.map.loading_map': 'Loading map...',
  'golf.map.no_alert_areas_found': 'No alert areas found.',
  'golf.map.no_areas_found': 'No areas found.',
  'golf.map.parking_areas': 'Parking Areas',
  'golf.map.refresh_map': 'Refresh Map',
  'golf.map.title': 'Map',
  'golf.map.total_golf_cars': 'Total Golf Cars:',
  'golf.map.visible': 'Visible:',
  'golf.map.zoom_in': 'Zoom in',
  'golf.map.zoom_out': 'Zoom out',
  'golf.menu.alert_areas': 'Alert Areas',
  'golf.menu.areas': 'Areas',
  'golf.menu.brand': 'Breeze Golf',
  'golf.menu.brand_subtitle': 'Executive Suite',
  'golf.menu.dashboard': 'Dashboard',
  'golf.menu.financial_reports': 'Financial Reports & Billing',
  'golf.menu.fleet': 'Fleet Management',
  'golf.menu.fleet_typo': 'Fleet Managment',
  'golf.menu.map': 'Map',
  'golf.menu.reserves': 'Reserves',
  'golf.menu.settings': 'Settings',
  'golf.menu.switch_ev': 'EV MODULE',
  'golf.menu.switch_golf': 'GOLF MODULE',
  'golf.menu.switch_p2p': 'P2P MODULE',
  'golf.menu.tariffs_settings': 'Tariff & Settings',
  'golf.menu.trips': 'Trips',
  'golf.menu.user_role': 'User Role',
  'golf.menu.users': 'Users',
  'golf.menu.users_access': 'User Role',
  'golf.promo.action_pause': 'Pause',
  'golf.promo.action_resume': 'Resume',
  'golf.promo.action_stop': 'Stop',
  'golf.promo.active': 'Active',
  'golf.promo.active_campaigns': 'Active Campaigns',
  'golf.promo.add_discount': 'Add New Discount',
  'golf.promo.all_campaigns': 'All promotional campaigns',
  'golf.promo.all_statuses': 'All Statuses',
  'golf.promo.all_users': 'All Users',
  'golf.promo.always_active': 'Always Active',
  'golf.promo.applies_to_all_tariffs_default':
    'Applies to all tariffs by default',
  'golf.promo.btn_auto_generate': 'Auto Generate',
  'golf.promo.btn_create_campaign': 'Create Campaign',
  'golf.promo.budget_limit': 'Budget Limit (₼)',
  'golf.promo.budget_prefix': 'Budget:',
  'golf.promo.bulk_generate': 'Bulk Generate',
  'golf.promo.bulk_generate_title': 'Bulk Generate 12-Character Promo Codes',
  'golf.promo.campaign_name': 'Campaign Name',
  'golf.promo.col_code_campaign': 'CODE & CAMPAIGN',
  'golf.promo.col_conditions': 'CONDITIONS',
  'golf.promo.col_discount': 'DISCOUNT',
  'golf.promo.col_usages_budget': 'USAGES & BUDGET',
  'golf.promo.col_validity': 'VALIDITY',
  'golf.promo.completed_redemptions': 'Completed trip redemptions',
  'golf.promo.copy_code': 'Copy Code',
  'golf.promo.create_promo_code': 'Create Promo Code',
  'golf.promo.currently_redeemable': 'Currently redeemable by guests',
  'golf.promo.customer_savings': 'TOTAL CUSTOMER SAVINGS',
  'golf.promo.dialog_create_campaign': 'Create Promo Campaign',
  'golf.promo.discount': 'DISCOUNT',
  'golf.promo.discount_type': 'Discount Type',
  'golf.promo.discount_value': 'Discount Value',
  'golf.promo.eg_campaign_name': 'e.g. Summer Golf Open 2026',
  'golf.promo.export_csv': 'Export CSV',
  'golf.promo.failed_save_promo': 'Failed to save promo code',
  'golf.promo.failed_stop_promo': 'Failed to stop promo code',
  'golf.promo.fixed_amount': 'Fixed Amount (₼)',
  'golf.promo.label_applicable_tariffs': 'Applicable Tariffs',
  'golf.promo.label_code_12_chars': 'Promo Code (12 Chars)',
  'golf.promo.label_max_discount_cap': 'Max Discount Cap (₼)',
  'golf.promo.label_min_order': 'Minimum Order (₼)',
  'golf.promo.label_restrict_new_users':
    'Restrict to first-time renters only (New Users)',
  'golf.promo.label_usage_limit_total': 'Usage Limit (Total)',
  'golf.promo.label_valid_from': 'Valid From',
  'golf.promo.label_valid_until': 'Valid Until',
  'golf.promo.max_prefix': 'Max:',
  'golf.promo.min_prefix': 'Min:',
  'golf.promo.must_be_12_chars': 'Must be 12 uppercase letters or numbers.',
  'golf.promo.new_users_only': 'New Users Only',
  'golf.promo.no_promo_codes_found': 'No Promo Codes Found',
  'golf.promo.paused': 'Paused',
  'golf.promo.percentage': 'Percentage (%)',
  'golf.promo.placeholder_12_chars': '12 CHARS CODE',
  'golf.promo.placeholder_optional_cap': 'Optional cap',
  'golf.promo.placeholder_optional_min': 'Optional min',
  'golf.promo.placeholder_unlimited': 'Unlimited if empty',
  'golf.promo.prefix_max6': 'Prefix (Max 6)',
  'golf.promo.promo_code': 'Promo Code',
  'golf.promo.promo_code_saved': 'Promo code created successfully',
  'golf.promo.promo_codes': 'Promo Codes',
  'golf.promo.search_placeholder': 'Search code or campaign...',
  'golf.promo.spent_budget': 'Spent Budget',
  'golf.promo.status_expired': 'Expired',
  'golf.promo.status_stopped': 'Stopped',
  'golf.promo.subtitle':
    'Manage 12-character promotional campaigns, discount rates, budget caps, and status controls.',
  'golf.promo.target_audience': 'Target Audience',
  'golf.promo.title': 'Promo Codes Engine',
  'golf.promo.total_active_label': 'Total Active:',
  'golf.promo.total_campaigns': 'Total Campaigns',
  'golf.promo.total_cumulative_discount': 'Total cumulative discount grant',
  'golf.promo.total_redemptions_label': 'Total Redemptions:',
  'golf.promo.total_usages': 'Total Usages',
  'golf.promo.uses': 'Uses:',
  'golf.promo.validity_window': 'Validity Window',
  'golf.promo.wallet_credit': 'Wallet Credit (₼)',
  'golf.reserves.active_reservations': 'ACTIVE RESERVATIONS',
  'golf.reserves.failed_load_reserves': 'Failed to load reservations',
  'golf.reserves.filter_payment': 'Filter by Payment',
  'golf.reserves.no_active_reservations': 'No active reservations',
  'golf.reserves.reservation_info': 'Reservation Information',
  'golf.reserves.title': 'Reserves',
  'golf.reserves.upcoming_cancelled_desc':
    'Upcoming or cancelled reservations tied to this user.',
  'golf.roles.access_except_users':
    'Access to All Modules EXCEPT Users & Access Control',
  'golf.roles.access_revoked': 'Access revoked',
  'golf.roles.admin': 'Admin',
  'golf.roles.col_last_active_timestamp': 'LAST ACTIVE TIMESTAMP',
  'golf.roles.col_module_permissions': 'MODULE PERMISSIONS',
  'golf.roles.col_team_member': 'TEAM MEMBER',
  'golf.roles.edit_team_member': 'Edit Team Member',
  'golf.roles.eg_email': 'name@company.com',
  'golf.roles.eg_first_name': 'e.g. Julian',
  'golf.roles.eg_last_name': 'e.g. Voss',
  'golf.roles.email': 'Email',
  'golf.roles.failed_revoke': 'Failed to revoke access',
  'golf.roles.failed_update_role': 'Failed to update role',
  'golf.roles.full_system_access': 'Full System Access Across All Modules',
  'golf.roles.invitation_sent': 'Invitation sent successfully',
  'golf.roles.invite_team_member': 'Invite New Team Member',
  'golf.roles.name': 'Name',
  'golf.roles.operator': 'Operator',
  'golf.roles.operator_access_desc':
    'Dashboard, Trips, Fleet Only. Blocked from Tariff, Users & Manual Payments.',
  'golf.roles.revoke_access': 'Revoke Access',
  'golf.roles.role': 'Role',
  'golf.roles.role_admin_desc': 'All Modules Enabled',
  'golf.roles.role_blocked_desc': '(Tariff, Users & Manual Payments Blocked)',
  'golf.roles.role_operator_desc': 'Dashboard, Trips, Fleet Management Only',
  'golf.roles.role_supervisor_desc':
    'Dashboard, Trips, Fleet Management, Financial Reports & Billing (Users Disabled)',
  'golf.roles.select_role': 'Select role',
  'golf.roles.send_secure_token': 'Send a secure onboarding token via email',
  'golf.roles.supervisor': 'Supervisor',
  'golf.roles.title': 'User Role',
  'golf.roles.total_active_admins': 'Total Active Admin Accounts:',
  'golf.roles.total_active_field': 'Total Active Field Personnel:',
  'golf.roles.update_role_for': 'Update role for {name}',
  'golf.roles.user_role_updated': 'User role updated',
  'golf.tariffs.applies_strictly_first_hour':
    'Applies strictly to the first 1 hour of rental.',
  'golf.tariffs.base_hourly_rate': 'Base Hourly Rate (₼)',
  'golf.tariffs.base_weekend_rate': 'Base Weekend Rate - Fri-Sun (₼)',
  'golf.tariffs.base_workday_rate': 'Base Workday Rate - Mon-Thu (₼)',
  'golf.tariffs.create_tariff': 'Create Tariff',
  'golf.tariffs.daily_price_calibration': 'Daily Price Calibration',
  'golf.tariffs.daily_price_calibration_desc':
    'Set base day rates and progressive long-term stay incentives.',
  'golf.tariffs.daily_pricing': 'Daily Pricing',
  'golf.tariffs.durations_min': 'Available Durations (min)',
  'golf.tariffs.eligibility_guards': 'Eligibility Guards & Security Deposit',
  'golf.tariffs.eligibility_guards_desc':
    'Risk management and financial safety protocols.',
  'golf.tariffs.failed_update_tariff': 'Failed to update tariff',
  'golf.tariffs.fixed_30min_help':
    'Fixed baseline price applied dynamically when user selects the short-duration 30-minute rental package.',
  'golf.tariffs.fixed_30min_rate': 'Fixed 30-Min Package Rate (₼)',
  'golf.tariffs.fixed_security_deposit': 'Fixed Security Deposit (₼)',
  'golf.tariffs.formula_preview_for': 'Formula Preview for {model}:',
  'golf.tariffs.global_tariffs': 'Global Tariffs',
  'golf.tariffs.hourly_price_calibration': 'Hourly Price Calibration',
  'golf.tariffs.hourly_pricing': 'Hourly Pricing',
  'golf.tariffs.hours_formula_preview': '{hours} Hours = {formula}',
  'golf.tariffs.per_day': '/day',
  'golf.tariffs.per_hour': '/hour',
  'golf.tariffs.short_term_economics_desc':
    'Define the short-term rental economics for transient guests.',
  'golf.tariffs.subsequent_hour_discount': 'Subsequent Hour Discount (%)',
  'golf.tariffs.subsequent_hour_discount_help':
    'Flat discount applied strictly to any hours accrued after the first hour.',
  'golf.tariffs.tariff_save_failed': 'Failed to save configuration.',
  'golf.tariffs.tariff_saved_success': 'Configuration saved successfully.',
  'golf.tariffs.tier_1': 'Tier 1 (2-7 Days)',
  'golf.tariffs.tier_2': 'Tier 2 (8-14 Days)',
  'golf.tariffs.tier_3': 'Tier 3 (15-30 Days)',
  'golf.tariffs.tier_4': 'Tier 4 (31+ Days)',
  'golf.tariffs.title': 'Tariff & Settings',
  'golf.tariffs.weekend': 'Weekend',
  'golf.tariffs.weekend_rate_label': 'Weekend Rate (₼)',
  'golf.tariffs.workday': 'Workday',
  'golf.tariffs.workday_rate_label': 'Workday Rate (₼)',
  'golf.tariffs.your_savings': '(Your Savings: {amount})',
  'golf.trips.account_verified': 'Account Verified',
  'golf.trips.accumulated_extensions': 'Accumulated Trip Extensions',
  'golf.trips.action_col': 'Action',
  'golf.trips.action_required': 'ACTION REQUIRED',
  'golf.trips.actions': 'Actions',
  'golf.trips.actor_col': 'Actor',
  'golf.trips.additional_charge_applied': 'Additional charge applied.',
  'golf.trips.after_trip_photos': 'After-Trip Photos',
  'golf.trips.amounts_label': 'Amounts',
  'golf.trips.approve': 'Approve',
  'golf.trips.assign_model': 'Assign Model',
  'golf.trips.assigned_stall': 'Assigned Stall',
  'golf.trips.base_rate_label': 'Base Rate',
  'golf.trips.base_rental_service_fee': 'Base Rental Service Fee',
  'golf.trips.booking_details': 'Booking Details',
  'golf.trips.cancel_trip': 'Cancel Trip',
  'golf.trips.cash': 'CASH',
  'golf.trips.cash_payment_notice':
    'This trip was paid in cash at the cashier. No card freeze/charge operations were performed.',
  'golf.trips.change_model_manually': 'Change Model Manually',
  'golf.trips.charge_amount': 'Charge Amount',
  'golf.trips.comment_col': 'Comment',
  'golf.trips.complete_trip': 'Complete Trip',
  'golf.trips.confirm_cash_settlement': 'CONFIRM CASH SETTLEMENT',
  'golf.trips.credit': 'CREDIT',
  'golf.trips.current_status': 'CURRENT STATUS',
  'golf.trips.daily_rental': 'DAILY RENTAL',
  'golf.trips.date_col': 'Date',
  'golf.trips.decline': 'Decline',
  'golf.trips.deposit': 'Deposit',
  'golf.trips.discounts_applied': 'Applied Discounts',
  'golf.trips.extended_by_user': 'Extended by User',
  'golf.trips.failed_assign_model': 'Failed to assign model',
  'golf.trips.failed_copy_id': 'Failed to copy ID',
  'golf.trips.financials': 'Financials',
  'golf.trips.finish_log_transaction': 'FINISH & LOG TRANSACTION',
  'golf.trips.freeze_amount': 'Freeze Amount',
  'golf.trips.freeze_order_id': 'Freeze Order ID',
  'golf.trips.hourly_rental': 'HOURLY RENTAL',
  'golf.trips.id_copied': 'ID copied to clipboard',
  'golf.trips.is_cash': 'Is Cash',
  'golf.trips.lifecycle_status': 'Lifecycle Status',
  'golf.trips.lifestyle_status': 'Lifecycle Status',
  'golf.trips.live_preview_box': 'LIVE PREVIEW BOX',
  'golf.trips.log_booking_approved': 'Booking Approved',
  'golf.trips.log_booking_created': 'Booking Created',
  'golf.trips.log_booking_declined': 'Booking Declined',
  'golf.trips.log_trip_cancelled': 'Trip Cancelled',
  'golf.trips.log_trip_completed': 'Trip Completed',
  'golf.trips.log_trip_put_on_hold': 'Trip Put On Hold',
  'golf.trips.log_trip_resumed': 'Trip Resumed',
  'golf.trips.log_trip_started': 'Trip Started',
  'golf.trips.manual_desk_reconciliation':
    'Manual desk reconciliation for this trip',
  'golf.trips.model_assigned_success': 'Model successfully assigned to trip',
  'golf.trips.model_id': 'Model ID',
  'golf.trips.no_aftertrip_photos': 'No after-trip photos',
  'golf.trips.no_logs_available': 'No logs available for this trip',
  'golf.trips.no_pretrip_photos': 'No pre-trip photos',
  'golf.trips.no_trips_found': 'No trips found',
  'golf.trips.payment_details': 'Payment Details',
  'golf.trips.payment_id': 'Payment ID',
  'golf.trips.payment_method': 'Payment Method',
  'golf.trips.payment_status': 'Payment Status',
  'golf.trips.per_minute_rental': 'PER MINUTE RENTAL',
  'golf.trips.pickup': 'PICKUP',
  'golf.trips.post_trip_return': 'POST-TRIP RETURN',
  'golf.trips.pre_trip_photos': 'Pre-Trip Photos',
  'golf.trips.pre_trip_verification': 'PRE-TRIP VERIFICATION',
  'golf.trips.put_on_hold': 'Put On Hold',
  'golf.trips.refund_amount': 'Refund Amount',
  'golf.trips.renter_profile': 'Renter Profile',
  'golf.trips.resume_trip': 'Resume Trip',
  'golf.trips.return': 'RETURN',
  'golf.trips.seats': 'Seats',
  'golf.trips.select_available_model_placeholder': 'Select available model...',
  'golf.trips.select_model_catalog': 'SELECT AVAILABLE MODEL IN SYSTEM',
  'golf.trips.showing_active_models_fleet':
    'Showing all active models across the fleet available for assignment.',
  'golf.trips.showing_results': 'Showing {start} to {end} of {total} results',
  'golf.trips.stall': 'Stall',
  'golf.trips.stall_number': 'Stall Number',
  'golf.trips.start_trip': 'Start Trip',
  'golf.trips.status_cancelled_admin': 'Cancelled (Admin)',
  'golf.trips.status_cancelled_user': 'Cancelled (User)',
  'golf.trips.tab_all': 'All trips',
  'golf.trips.tab_approved': 'Approved',
  'golf.trips.tab_cancelled': 'Cancelled',
  'golf.trips.tab_completed': 'Finished',
  'golf.trips.tab_on_hold': 'On Hold',
  'golf.trips.tab_ongoing': 'Ongoing',
  'golf.trips.tab_pending': 'Pending',
  'golf.trips.title': 'Trips',
  'golf.trips.total_amount_label': 'Total Amount',
  'golf.trips.total_cash_due': 'TOTAL CASH DUE',
  'golf.trips.total_credit_due': 'TOTAL CREDIT CARD DUE',
  'golf.trips.trigger_action': 'TRIGGER ACTION',
  'golf.trips.trip_details': 'Trip Details',
  'golf.trips.trip_extended_user': 'Trip extended by user',
  'golf.trips.trip_finance': 'TRIP FINANCE',
  'golf.trips.trip_logs': 'TRIP LOGS',
  'golf.trips.trip_photos': 'TRIP PHOTOS',
  'golf.trips.trip_status': 'Trip Status',
  'golf.trips.trip_total': 'Trip Total',
  'golf.trips.vehicle_model': 'Vehicle Model',
  'golf.trips.view_details': 'View Details',
  'golf.users.account_profile': 'ACCOUNT PROFILE',
  'golf.users.audit_documentation': 'AUDIT DOCUMENTATION',
  'golf.users.balance': 'Balance',
  'golf.users.base': 'Base',
  'golf.users.block': 'Block',
  'golf.users.copy_user_id': 'Copy User ID',
  'golf.users.current_balance': 'Current Balance:',
  'golf.users.description': 'Description',
  'golf.users.driver_license': 'Driver License',
  'golf.users.failed_update_status': 'Failed to update status',
  'golf.users.filter_golf_status': 'Filter by Golf Status',
  'golf.users.golf_statistics': 'GOLF STATISTICS',
  'golf.users.identifications': 'IDENTIFICATIONS',
  'golf.users.last_trip_date': 'Last Trip Date',
  'golf.users.latest_bookings_desc': 'Latest bookings placed by this renter.',
  'golf.users.latest_reserves': 'Latest Reserves',
  'golf.users.linked_cards_desc': "Cards linked to this renter's account.",
  'golf.users.loaded': 'loaded',
  'golf.users.no_cards_on_file': 'No payment cards on file',
  'golf.users.no_financial_operations': 'No financial operations logged yet',
  'golf.users.no_reserves_found':
    'No golf car reservations were found for this user',
  'golf.users.no_trips_recorded': 'No trips recorded for this renter',
  'golf.users.no_trips_yet': 'No trips yet',
  'golf.users.not_set': 'Not set',
  'golf.users.on_file': 'on file',
  'golf.users.operation': 'Operation',
  'golf.users.outstanding_amount_warning':
    'Outstanding amount must be cleared before the user can book again.',
  'golf.users.passport_id': 'Passport or ID',
  'golf.users.payment_cards': 'Payment Cards',
  'golf.users.pricing': 'Pricing',
  'golf.users.recent_trips': 'Recent Trips',
  'golf.users.renter_access_desc':
    'This user has access to the Golf Module and can book trips as Renter.',
  'golf.users.reserve': 'Reserve',
  'golf.users.reserved_window': 'Reserved Window',
  'golf.users.title': 'Users',
  'golf.users.total_trips': 'Total Trips',
  'golf.users.trip': 'Trip',
  'golf.users.unblock': 'Unblock',
  'golf.users.user_info': 'USER INFO',
  'golf.users.user_status_updated': 'User status updated successfully',
  'golf.users.users_exported': 'Users exported successfully',
  'golf.users.wallet_state_desc':
    'Wallet state for this renter across golf trips.',
  'golf.users.years': 'years',
  'golf.zones.title': 'Resort Deployment Zone',
}
export default en
